
import posthog from 'posthog-js';
import { PostHogProvider as PHProvider } from 'posthog-js/react';
import { useEffect, ReactNode } from 'react';
import { useLocation } from 'react-router';
import { getPostHogEnvironment } from '@/lib/posthog';

// Module-level init — runs synchronously before any React component mounts,
// ensuring posthog.identify() calls always hit an initialized instance.
const key = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
if (key) {
    posthog.init(key, {
        api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com',
        person_profiles: 'identified_only',
        capture_pageview: false,
        capture_pageleave: true,
        debug: import.meta.env.DEV,
    });
    posthog.register({
        environment: getPostHogEnvironment(),
    });
}

export function PostHogPageView() {
    const location = useLocation();

    useEffect(() => {
        posthog.capture('$pageview');
    }, [location]);

    return null;
}

export function PostHogProvider({ children }: { children: ReactNode }) {
    return <PHProvider client={posthog}>{children}</PHProvider>;
}
